/**
 * Campana ROJA · qué recibos devueltos se avisan.
 *
 * REGLA DE ANN (14-sep-2026, literal):
 *   «la campana roja debe mostrar solo las deudas RECUPERABLES PENDIENTES
 *    con clientes DE ALTA»
 *
 * Es un AVISO de trabajo por hacer, no un informe. Si ya no hay nada que
 * recobrar, no debe sonar: el recepcionista solo tiene que ver lo que aún
 * puede cobrar.
 *
 * OJO: esto filtra SOLO la campana. La pantalla «Recibos Devueltos» sigue
 * enseñándolo TODO (incluidos incobrables y bajas). No se toca.
 */

const MESES_ES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
  'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

/** Estado terminal por incobrable: la deuda ya no se considera recuperable. */
export const ESTADO_INCOBRABLE = 'propuesta_incobrable';

/**
 * Las tres condiciones de Ann, una por línea:
 *   PENDIENTE   -> `abierta` (el backend ya calcula estado in ESTADOS_ABIERTOS:
 *                  deja fuera cobrado, cerrado_con_deuda, cerrado_error_admin
 *                  y cerrado_condonado)
 *   DE ALTA     -> la clienta no está de baja
 *   RECUPERABLE -> no está propuesta como incobrable
 */
export function esDeudaRecuperablePendiente(d) {
  if (!d) return false;
  if (d.abierta !== true) return false;
  if (d.cliente_de_baja === true) return false;
  if (d.estado === ESTADO_INCOBRABLE) return false;
  return true;
}

/**
 * Mes devuelto EN LETRA, junto al nombre, para que Ann supervise de un vistazo
 * si algo se está atascando. El año solo se escribe cuando no es el actual.
 */
export function mesDevueltoLabel(d, anyoActual = new Date().getFullYear()) {
  const m = Number(d?.periodo_mes);
  if (!Number.isInteger(m) || m < 1 || m > 12) return '';
  const nombre = MESES_ES[m - 1];
  const a = Number(d?.periodo_anyo);
  if (Number.isInteger(a) && a > 0 && a !== Number(anyoActual)) return `${nombre} ${a}`;
  return nombre;
}

/** Lo que pinta la campana: filtrado y con lo más reciente arriba. */
export function devolucionesParaCampana(items, anyoActual) {
  const lista = Array.isArray(items) ? items.filter(esDeudaRecuperablePendiente) : [];
  return lista.sort((a, b) =>
    String(b?.fecha_devolucion || '').localeCompare(String(a?.fecha_devolucion || '')));
}

export { MESES_ES };
